import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { DEFAULT_FILTER_COMMISSIONS_BATCHES_QUERY_PARAMS } from "../api";
import { CommissionsBatchFilter } from "../components/CommissionsBatchFilter";
import { CommissionsBatchTable } from "../components/tables/CommissionsBatchTable";
import { CommissionsBatchFilterPageRequest } from "../types";

export const CommissionsBatchListContainer = () => {
  const searchParams = useFilterSearchParams<CommissionsBatchFilterPageRequest>({
    params: ["steps"],
    defaultQueryParamsObject: DEFAULT_FILTER_COMMISSIONS_BATCHES_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <CommissionsBatchFilter searchParams={searchParams} />

      <CommissionsBatchTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
